<template>
	<div class="active-list">
		<filter-panel :data="myGroups" @change="change" @search="filterChange"></filter-panel>
		<data-list
			:table-style="{ name: 'mixture' }"
			:columns="columns"
			:data="data"
			:page="page"
			:loading="loading"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>
		<dialog-form
			:dialogVisible="dialogVisible"
			:attributes="attribute"
			:showBtn="false"
			@close:dialogVisible="
				val => {
					dialogVisible = val;
				}
			"
		>
			<div slot="main">
				<el-input
					type="textarea"
					placeholder="输入备注"
					show-word-limit
					:rows="5"
					:maxlength="100"
					v-model="remark"
				></el-input>
				<div class="footer">
					<el-button @click="handleClose">取消</el-button>
					<el-button type="primary" @click="setRemark">确定</el-button>
				</div>
			</div>
		</dialog-form>
		<!-- 预警规则 -->
		<monitoring-rules
			class="monitoring-rules"
			ref="rules"
			:serviceId="serviceId"
			:showDoalog="showDoalog"
			:attributes="attributes"
			:formData="rulesFormData"
			:groups="rulesGroup"
			:columns="rulesColumns"
			@saveCost="saveCost"
			@close:dialogVisible="close"
		></monitoring-rules>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import dialogForm from '@/components/dialogForm/dialogForm.vue';
import googleAds from '@/backend/services/googleAds/googleAds.js';
import filters from '@/mixins/filters.js';
import monitoringRules from '@/components/googleAdsCom/monitoringRules';
import { validRequired } from '@/common/elementValid.js';
import messageSwitch from '@/components/customer/messageSwitch';
import inputInsertion from '@/components/googleAdsCom/inputInsertion.vue';
import { warningPriority, warningStatus } from '@/common/dictionary.js';
import customer from '@/mixins/customer';
import googleAdsIput from '@/components/googleAdsCom/googleAdsIput';
import { encode } from '@/common/util.js';
import { mapGetters } from 'vuex';

const _typeof = item => typeof item == 'undefined';
const { filters: filter } = filters;
const dataList = listPageCreate({
	searchConfig: {
		api: api.googleAds.inactiveList,
		method: 'POST',
	},
	getQuery(obj, that) {
		if (!obj.startDate && !obj.endDate) {
			_.assign(obj, that.initDate);
		}
		if (_typeof(obj.activeStatus)) obj.activeStatus = '0';
		if (_typeof(obj.serviceStaffId)) obj.serviceStaffId = that.userId;
		that.searchType = obj.activeStatus == '' ? 2 : -1;
		return _.assign(obj, {
			searchType: that.searchType,
			customerId: that.CUSTOMER,
		});
	},
});
export default {
	name: 'inactiveList',
	components: {
		filterPanel,
		dialogForm,
		monitoringRules,
	},
	props: {
		groups: Object,
		initDate: Object,
	},
	mixins: [dataList, customer],
	data() {
		return {
			columns: '',
			dialogVisible: false,
			myGroups: _.cloneDeep(this.groups),
			searchType: -1,
			remark: '',
			serviceId: '',
			showDoalog: false,
			attributes: {
				width: '50%',
				destroy: true,
				title: '监测设置',
			},
			rulesFormData: {},
			rulesGroup: {},
			rulesColumns: [],
			warningTypeList: [],
			openFlag: '',
			ruleVal: [],
			ruleVals: {},
			disabled: true,
			attribute: {
				title: '备注',
				width: '550px',
			},
		};
	},
	computed: {
		...mapGetters(['userId']),
	},
	watch: {
		groups: {
			handler(val) {
				this.myGroups = _.cloneDeep(val);
			},
		},
	},

	methods: {
		change(col) {
			//子状态  0 待激活  2  暂停  3 死亡
			if (col.prop == 'activeStatus') {
				this.setColumns(col.value);
			}
		},
		handleClose() {
			this.dialogVisible = false;
		},
		setColumns(subStatus = 0) {
			/**
			 * 待激活状态  暂停 死亡  显示"-"
			 * 暂停状态    暂停时间显示
			 * 死亡状态    死亡时间显示
			 */
			const self = this;
			const buildStateTime = (label, bind = 'statusChangeTime') => {
				let column = {
					label: label,
					bind: bind,
				};
				const _indexOf = str => label.indexOf(str);
				if (subStatus == 2 && _indexOf('暂停') >= 0) {
					return column;
				} else if (subStatus == 3 && _indexOf('死亡') >= 0) {
					return column;
				} else {
					return {
						label: label,
						bind: '',
					};
				}
			};
			const linkToDetails = row => {
				self.$router.push({
					name: 'serviceDefault',
					query: {
						serviceId: row.serviceId,
						customerId: row.custId,
						// ruleItemId: row.ruleItemId,
						customerName: encode(row.custName),
						cid: row.cid,
						serviceCode: encode(row.serviceCode),
					},
				});
			};
			this.columns = [
				{
					label: '授权状态',
					bind: 'authorizationStatus',
					type: 'mapping',
					width: '120px',
					mapType: 'iconfont',
					align: 'left',
					size: { fontSize: '23px' },
					parentEvent: row => {
						let status = [
							{ label: 'remind1', value: 0 },
							{ label: 'fasongchenggong', value: 1 },
						];
						return status.find(item => row == item.value).label;
					},
					colors: row => {
						let status = [
							{ label: { color: '#FCC262' }, value: 0 },
							{ label: { color: '#78CE4D' }, value: 1 },
						];
						return status.find(item => row.authorizationStatus == item.value).label;
					},
					message: row => {
						let status = [
							{ label: '无效', value: 0 },
							{ label: '有效', value: 1 },
						];
						return status.find(item => row.authorizationStatus == item.value).label;
					},
				},
				{
					type: 'custInfo',
					label: '客户',
					text: [
						{
							bind: 'custName',
						},
						{
							label: '服务人员',
							bind: 'serviceStaffName',
						},
						{
							label: '服务单号',
							bind: 'serviceCode',
						},
						{
							label: '推广网站',
							bind: 'domain',
							clickFn(text) {
								if (text) {
									if (text.includes('：')) {
										const domain = text.split('：').pop();
										if (domain != '-') window.open(`//${domain}`);
									}
								}
							},
						},
					],
				},
				{
					label: '账户余额',
					bind: 'balance',
					align: 'center',
					width: 180,
					type: 'percentage',
					dataStyle(val) {
						return filter.rmb(val);
					},
				},
				{
					label: 'CID',
					type: 'custInfo',
					text: [
						{
							bind: 'cid',
						},
					],
				},
				{
					label: '订单号',
					type: 'custInfo',
					text: [
						{
							bind: 'orderCode',
						},
					],
				},
				{
					label: 'CID绑定时间',
					bind: 'accountOpenTime',
				},
				buildStateTime('暂停时间'),
				buildStateTime('死亡时间'),
				{
					label: '子状态',
					bind: 'activeStatusName',
				},
				{
					type: 'btnClick',
					style: 'text',
					label: '操作',
					align: 'center',
					width: 100,
					bind(row) {
						//状态:0:待激活,1:已激活,2:暂停,3:死亡
						if (row.activeStatus == 0) {
							return [
								{
									text: '监测设置',
									trigger: async row => {
										self.serviceDetail = row;
										// 获取kpi和询盘成本
										let res = await googleAds.budgetCost(row.id);
										let kpi = res.data && res.data.kpi;
										let inquiryCost = res.data && res.data.inquiryCost;
										self.setformData({
											kpi,
											inquiryCost,
										});
										await self.setServiceId(row.serviceId);
										self.$refs.rules.query();
										self.showDoalog = true;
									},
								},
							];
						} else {
							return [
								{
									text: '备注',
									trigger: () => {
										self.rowData = row;
										self.remark = row.statusRemarks ? row.statusRemarks : '';
										self.dialogVisible = true;
									},
								},
								{
									text: '详情',
									trigger: () => {
										linkToDetails(row);
									},
								},
							];
						}
					},
				},
			];
		},
		setServiceId(id) {
			return new Promise(reject => {
				this.serviceId = id;
				reject();
			});
		},
		async setRemark() {
			const { id } = this.rowData;
			const { remark } = this;
			try {
				let res = await googleAds.modifyRemark({ id }, { remark });
				if (res.status >= 200 && res.status < 400) {
					this.$message.success('备注状态修改成功');
					this.dialogVisible = false;
					this.query();
				}
			} catch (e) {
				console.error(e);
				this.$message.info('备注状态修改失败');
			}
		},
		// 配置rulesFormData
		setformData(val) {
			this.rulesFormData = {
				// kpi: {
				// 	before: '￥',
				// 	after: '/天',
				// 	formType: googleAdsIput,
				// 	value: val.kpi || '',
				// 	placeholder: '请输入',
				// 	label: '预算',
				// 	labelWidth: '85px',
				// 	defaultKey: this.defaultKey,
				// 	options: [],
				// 	rules: [validRequired('此项必填', 'blur')],
				// },
				inquiryCost: {
					before: '￥',
					after: '/个',
					formType: googleAdsIput,
					value: val.inquiryCost || '',
					placeholder: '请输入',
					label: '询盘成本',
					labelWidth: '120px',
					defaultKey: this.defaultKey,
					options: [],
					rules: [validRequired('此项必填', 'blur')],
				},
			};
		},
		// 配置rulesGroups
		setgroups() {
			let that = this;
			this.rulesGroup = {
				others: [
					{
						tagName: 'sky-select',
						placeholder: '全部预警',
						label: '全部预警',
						options: that.warningTypeList,
						prop: 'ruleId',
						props: {
							label: 'name',
							value: 'id',
						},
						value: '',
					},
					{
						tagName: 'sky-select',
						placeholder: '全部优先级',
						label: '全部优先级',
						options: warningPriority,
						prop: 'priority',
						value: '',
					},
					{
						tagName: 'sky-select',
						placeholder: '全部状态',
						label: '全部状态',
						options: warningStatus,
						prop: 'openFlag',
						value: '',
					},
				],
			};
		},
		// 配置rulesColumns
		setcolumn() {
			let that = this;
			this.rulesColumns = [
				{
					label: '开启状态',
					bind: 'openFlag',
					type: 'custom',
					width: 100,
					componentName: messageSwitch,
					inactiveValue: 0,
					activeValue: 1,
					event(row, val) {
						that.openFlag = { val, ruleItemId: row.ruleItemId };
					},
				},
				{
					label: '预警',
					type: 'custInfo',
					width: 200,
					text: [
						{
							label: '',
							bind: 'ruleItemName',
						},
						{
							label: '类型',
							bind: 'ruleName',
						},
						{
							label: '优先级',
							bind: 'priorityStr',
						},
					],
				},
				{
					label: '撞线规则',
					bind: 'template',
					default: 'ruleVals',
					type: inputInsertion,
					change(val, index, row) {
						try {
							val = parseFloat(val);
							if (!val || typeof val != 'number') {
								that.$message({
									message: '请输入数值且不为空',
									type: 'warning',
								});
								if (!row.id) {
									that.ruleVals = false;
								}
								return false;
							}
							let oldId = that.ruleVals.ruleItemId;
							let newId = row.ruleItemId;
							if (oldId && newId && oldId != newId) {
								that.ruleVal = [];
								that.ruleVals = {};
							}

							that.ruleVal[index] = val;
							that.ruleVals = {
								val: that.ruleVal,
								ruleItemId: row.ruleItemId,
							};
						} catch (error) {
							this.$message({
								message: '数值错误，请重新输入',
								type: 'warning',
							});
						}
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					width: 100,
					align: 'center',
					bind: [
						{
							text: '保存',
							loading: true,
							async trigger(val, self) {
								let { openFlag, ruleVals, ruleVal } = that;
								// 数值校验
								if (ruleVal.length != 0) {
									if (!that.verifyData(ruleVals)) return false;
								}

								let { id, ruleId, ruleItemId } = val;
								let param = {
									ruleId,
									ruleItemId,
									serverId: that.serviceDetail.id,
									serviceId: that.serviceId,
								};
								// 传值判断
								if (id) {
									param.id = id;
								}
								if (openFlag.ruleItemId == val.ruleItemId) {
									param.openFlag = openFlag.val;
								} else {
									param.openFlag = val.openFlag;
								}
								if (ruleVals.ruleItemId == val.ruleItemId) {
									param.ruleVals = ruleVals.val;
								} else {
									param.ruleVals = val.ruleVals;
								}
								let res = await googleAds.editMonitoringRules(param);
								if (res.status == 200) {
									that.$message({
										message: '保存成功',
										type: 'success',
									});
								} else {
									that.$message({
										message: '保存异常，请重试',
										type: 'warning',
									});
								}
								self.loading = false;
							},
						},
					],
				},
			];
		},
		// 取消
		close(val) {
			this.showDoalog = val;
			this.query();
		},
		// 保存预算和成本
		async saveCost() {
			try {
				let { rulesFormData, disabled } = this;
				if (!disabled) return false;
				this.disabled = false;
				let { id } = this.serviceDetail;
				// let kpi = rulesFormData.kpi.value;
				let inquiryCost = rulesFormData.inquiryCost.value;
				await googleAds.updateCost({
					id,
					inquiryCost,
				});
				this.disabled = true;
				this.$message({
					message: '操作成功',
					type: 'success',
				});
			} catch (error) {
				this.disabled = true;
				this.$message({
					message: '操作失败，请重试',
					type: 'warning',
				});
			}
		},
		// 获取预警类别列表
		async getWarningType() {
			let res = await googleAds.warningTypeList();
			this.warningTypeList = res.data;
			this.setgroups();
		},
		// 数值校验
		verifyData(ruleVals) {
			if (!ruleVals) {
				this.$message({
					message: '请修改数据，值不可以为空',
					type: 'warning',
				});
				return false;
			}
			if (!ruleVals.val || ruleVals.val.length == 0) {
				this.$message({
					message: '请修改数据，值不可以为空',
					type: 'warning',
				});
				return false;
			}
			let arrVal = ruleVals.val.filter(item => !item || typeof item != 'number');
			if (arrVal.length != 0) {
				this.$message({
					message: '请输入数值且不为空',
					type: 'warning',
				});
				return false;
			}
			return true;
		},
	},
	created() {
		this.setColumns();
		this.myGroups.others.forEach(item => {
			if (item.prop == 'serviceStaffId') {
				this.$set(item, 'value', this.userId);
			}
		});
	},
	activated() {
		this.query();
	},
	mounted() {
		this.getWarningType();
		this.setcolumn();
	},
};
</script>

<style lang="scss" scoped>
.footer {
  text-align: right;
  margin-top: 20px;
}
</style>
